export const ContentBlockFields = {
  heading: {
    type: "text",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading (e.g. 'About Us', 'Our Mission')",
      seo: true,
      key: "content.heading",
    },
  },
  content: {
    type: "textarea",
    label: "Content",
    metadata: {
      source: "ai",
      description: "Main content text (2-3 paragraphs)",
      seo: true,
      key: "content.body",
    },
  },
  imageUrl: {
    type: "custom",
    label: "Image",
    metadata: {
      source: "manual", // User selects from image library or uploads
      description: "URL for a relevant image",
      seo: false,
    },
  },
  imageAlt: {
    type: "text",
    label: "Image Alt Text",
    metadata: {
      source: "manual", // User provides alt text for accessibility/SEO
      description: "Descriptive alt text for the image",
      seo: true,
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Image Left, Text Right", value: "image-left" },
      { label: "Image Right, Text Left", value: "image-right" },
      { label: "Centered (No Image or Image Above)", value: "centered" },
      { label: "Text Only (No Image)", value: "no-image" },
      { label: "Statement (Big Heading Left, Text Right)", value: "statement" },
    ],
    metadata: {
      source: "manual",
    },
  },
  imageStyle: {
    type: "radio",
    label: "Image Style",
    options: [
      { label: "Shadow", value: "shadow" },
      { label: "Border", value: "border" },
      { label: "None", value: "none" },
    ],
    metadata: {
      source: "manual",
      description: "Framing around the image. Choose None for logos and marks.",
    },
  },
  backgroundColor: {
    type: "radio",
    label: "Background Color",
    options: [
      { label: "White", value: "white" },
      { label: "Light Gray", value: "gray" },
      { label: "Primary Tint", value: "primary" },
    ],
    metadata: {
      source: "manual",
    },
  },
  headingSize: {
    type: "radio",
    label: "Heading Size",
    options: [
      { label: "Large", value: "large" },
      { label: "Medium", value: "medium" },
      { label: "Small", value: "small" },
    ],
    metadata: {
      source: "manual",
    },
  },
} as const;
